import Input from '../../../common/Input';
import DatePicker, {defaultDateFormat} from '../../../common/DatePicker';
import SimpleDatePicker from "../../../common/SimpleDatePicker";

export default {
    id: 0,

    name: 'disciplinary_actions',
    _system: {
        name: 'Disciplinary Actions',
        relatedTo: 'disciplinary_actions',
    },
    date_from: {
        label: 'Date From',
        hideLabel: true,
        placeholder: 'Add Date From',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            component: SimpleDatePicker,
            name: 'date_from',
            relatedTo: 'disciplinary_actions'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'date_from',
        rules: {
            title: 'Date From field'
        }
    },
    date_to: {
        label: 'Date To',
        hideLabel: true,
        placeholder: 'Add Date To',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            component: SimpleDatePicker,
            name: 'date_to',
            relatedTo: 'disciplinary_actions'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'date_to',
        rules: {
            title: 'Date To field'
        }
    },
    details: {
        label: 'Details',
        hideLabel: true,
        placeholder: 'Add Details',
        system: {
            component: Input,
            name: 'details',
            relatedTo: 'disciplinary_actions'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'details',
        rules: {
            title: 'Details field',
        },
        grid: {
            className: 'col col-7'
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/Employee/fields/disciplinary_actions.js